export default "__VITE_ASSET__920a59d6__"